import styled from 'styled-components';

export const ConfigurationTabContainer = styled.div`
	padding: 1rem;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const StyledConfigCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	max-width: 70%;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 0.25rem;
	padding: 1rem;
	background: white;
`;

export const ConfigCardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 1rem;
	border-bottom: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	padding-bottom: 1rem;
`;

export const ConfigCardTitle = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.v2.color.neutral[900]};
`;

export const ConfigCardDescription = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.v2.color.neutral[600]};
	line-height: 1.5;
`;

export const CadenceFieldsRow = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
`;

export const CadenceText = styled.span`
	font-size: 14px;
	color: ${({ theme }) => theme.v2.color.neutral[700]};
`;

export const PreviewLine = styled.div`
	font-size: 13px;
	font-style: italic;
	color: ${({ theme }) => theme.v2.color.neutral[600]};
	line-height: 1.5;
`;

export const ConfigCardFooter = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const ScheduledQueueTabContainer = styled.div`
	padding: 1rem;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
